export default __webpack_public_path__ + "static/media/24.fe67ed0d.svg";